import f from "../../@babel/runtime/helpers/esm/extends.mjs";
import m from "../../@babel/runtime/helpers/esm/classCallCheck.mjs";
import d from "../../@babel/runtime/helpers/esm/createClass.mjs";
import p from "../../@babel/runtime/helpers/esm/assertThisInitialized.mjs";
import c from "../../@babel/runtime/helpers/esm/inherits.mjs";
import h from "../../@babel/runtime/helpers/esm/createSuper.mjs";
import l from "../../@babel/runtime/helpers/esm/defineProperty.mjs";
import v, { Component as C } from "react";
import _ from "./AjaxUploader.mjs";
function a() {
}
var U = /* @__PURE__ */ function(s) {
  c(e, s);
  var n = h(e);
  function e() {
    var r;
    m(this, e);
    for (var t = arguments.length, i = new Array(t), o = 0; o < t; o++)
      i[o] = arguments[o];
    return r = n.call.apply(n, [this].concat(i)), l(p(r), "uploader", void 0), l(p(r), "saveUploader", function(u) {
      r.uploader = u;
    }), r;
  }
  return d(e, [{
    key: "abort",
    value: function(t) {
      this.uploader.abort(t);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ v.createElement(_, f({}, this.props, {
        ref: this.saveUploader
      }));
    }
  }]), e;
}(C);
l(U, "defaultProps", {
  component: "span",
  prefixCls: "rc-upload",
  data: {},
  headers: {},
  name: "file",
  multipart: !1,
  onStart: a,
  onError: a,
  onSuccess: a,
  multiple: !1,
  beforeUpload: null,
  customRequest: null,
  withCredentials: !1,
  openFileDialogOnClick: !0,
  hasControlInside: !1
});
export {
  U as default
};
//# sourceMappingURL=Upload.mjs.map
